import type { ReactNode } from 'react'

interface StatTileProps {
  readonly label: string
  readonly value: string
  /** Kurze Einordnung unter der Zahl, etwa "von 1.240 gesamt". */
  readonly context?: string
  readonly isLoading?: boolean
}

/**
 * Eine einzelne Kennzahl.
 *
 * Bewusst kein Diagramm: Wenn die Aussage aus genau einer Zahl besteht,
 * ist die Zahl die beste Darstellung. Ein Balken mit nur einem Balken
 * kostet Platz und sagt nichts zusätzlich.
 */
export function StatTile({ label, value, context, isLoading = false }: StatTileProps): ReactNode {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-800">
      <p className="text-xs font-medium text-slate-500 dark:text-slate-400">{label}</p>
      {isLoading ? (
        <div className="mt-2 h-8 w-24 animate-pulse rounded bg-slate-200 dark:bg-slate-700" />
      ) : (
        <p className="mt-1 text-3xl font-semibold tabular-nums text-slate-900 dark:text-slate-100">
          {value}
        </p>
      )}
      {context !== undefined && !isLoading && (
        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{context}</p>
      )}
    </div>
  )
}
